import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import * as React from 'react';

import { AdFoxBannerTracker } from '../AdFoxBannerTracker';

export interface IAdFoxTemplateParams {
  type: string;
}

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  return <AdFoxBannerTracker {...props} />;
};
